export default "__VITE_ASSET__C4icQv01__"